import React from "react";
import Layout from "../components/common/layout";
import "../assets/styles/index.scss";
import "../assets/styles/card.scss";
import { Link } from "gatsby";
import { graphql } from "gatsby";
import Img from "gatsby-image";

export const query = graphql`
  query {
    guideImg: file(relativePath: { eq: "guide_img.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    tableImg: file(relativePath: { eq: "table_img.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`;

export default ({ data }) => {
  return (
    <Layout>
      <section className="section" style={{ paddingTop: "1.5rem" }}>
        <div className="container">
          {/* <section className="mobileSectionPadding">
            <div className="notification is-info">
              New! Check out the latest guide:{" "}
              <Link to="/guides/mesos-guide">Mesos Guide</Link>
            </div>
          </section> */}

          <div className="columns desktopColumnPadding has-text-centered">
            <div className="column">
              <div className="card is-shady">
                <div className="card-image">
                  <figure className="image">
                    <Img
                      style={{ maxHeight: 225 }}
                      fluid={data.guideImg.childImageSharp.fluid}
                      alt="Maple Guide image"
                    />
                  </figure>
                </div>
                <div className="card-content">
                  <div>
                    <p className="title has-text-centered is-4">Guides</p>
                  </div>

                  <div className="content">
                    Minimize mistakes. Maximize fun!
                  </div>
                  <div className="content">
                    <ul>
                      <li style={{ marginLeft: 50, textAlign: "left" }}>
                        {`(Latest) `}
                        <Link to="/guides/progression">Progression Guide</Link>
                      </li>
                      <li style={{ marginLeft: 50, textAlign: "left" }}>
                        <Link to="/guides/mesos-guide">Mesos Guide</Link>
                      </li>
                      <li style={{ marginLeft: 50, textAlign: "left" }}>
                        <Link to="/guides/sf-guide">
                          Basic Starforcing Guide
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="column">
              <div className="card is-shady">
                <div className="card-image">
                  <figure className="image">
                    <Img
                      fluid={data.tableImg.childImageSharp.fluid}
                      alt="Maple table img"
                      style={{ maxHeight: 225 }}
                    />
                  </figure>
                </div>
                <div className="card-content">
                  <div>
                    <p className="title is-4 has-text-centered">Tables</p>
                  </div>

                  <div className="content">
                    All the data you need. In one place.
                  </div>
                  <div className="content">
                    <ul>
                      <li style={{ marginLeft: 50, textAlign: "left" }}>
                        {`(NEW) `}
                        <Link to="/tables/hypers">Hyper Stats</Link>
                      </li>
                      <li style={{ marginLeft: 50, textAlign: "left" }}>
                        <Link to="/tables/powder">
                          Powder Cost + Calculator
                        </Link>
                      </li>
                      <li style={{ marginLeft: 50, textAlign: "left" }}>
                        <Link to="/tables/weapons">
                          Weapon PBA (Perfect Base Attack)
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
